// extracted by mini-css-extract-plugin
export default {"dataframePage":"DataframePage_dataframePage__c9UF0","mainContent":"DataframePage_mainContent__SUNiF"};